import React from "react";
import { useHistory } from "react-router-dom";

import { Box, Typography, Stack, Grid } from "@mui/material";

import {
  AutoAwesome as SparkleIcon,
  Bolt as InstantIcon,
  CheckCircle as VerifiedIcon,
  AddCircleOutline as AddIcon,
} from "@mui/icons-material";

import { colors, borderRadiusPx } from "../../../../../theme";
import { CommonChip, CommonButton } from "../../../../Components/ui";
import { Path } from "../../../../../static/Constants";

const SlotHeroBanner = ({
  totalActive = 0,
  combinedPrize = "0.00",
  currency = "BET",
}) => {
  const history = useHistory();
  return (
    <Box sx={{ mb: 4 }}>
      <Box className="slot-hero-banner" sx={{ p: { xs: 3, md: 4 } }}>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} md={7}>
            <Stack
              direction="row"
              alignItems="center"
              spacing={1.5}
              sx={{ mb: 1.5 }}
            >
              <Box
                sx={{
                  position: "relative",
                  width: 44,
                  height: 44,
                  borderRadius: borderRadiusPx.md,
                  bgcolor: "#faf5ff",
                  border: "1.5px solid #e9d5ff",
                  boxShadow: "0 2px 8px rgba(139, 92, 246, 0.15)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                }}
              >
                <Typography
                  sx={{
                    position: "absolute",
                    left: 6,
                    top: 8,
                    fontSize: "1.35rem",
                    lineHeight: 1,
                    fontWeight: 900,
                    color: "#a855f7",
                    transform: "rotate(-14deg)",
                    opacity: 0.45,
                    zIndex: 1,
                    userSelect: "none",
                  }}
                >
                  7
                </Typography>

                <Typography
                  sx={{
                    position: "absolute",
                    left: "50%",
                    top: "50%",
                    transform: "translate(-50%, -50%)",
                    fontSize: "1.65rem",
                    lineHeight: 1,
                    fontWeight: 900,
                    color: "#7c3aed",
                    zIndex: 3,
                    userSelect: "none",
                    filter: "drop-shadow(0 0 6px rgba(139, 92, 246, 0.4))",
                  }}
                >
                  7
                </Typography>

                <Typography
                  sx={{
                    position: "absolute",
                    right: 6,
                    top: 8,
                    fontSize: "1.35rem",
                    lineHeight: 1,
                    fontWeight: 900,
                    color: "#a855f7",
                    transform: "rotate(14deg)",
                    opacity: 0.45,
                    zIndex: 1,
                    userSelect: "none",
                  }}
                >
                  7
                </Typography>
              </Box>

              <Box>
                <Typography
                  variant="overline"
                  sx={{
                    color: "#8b5cf6",
                    fontWeight: 800,
                    letterSpacing: 1.2,
                  }}
                >
                  LIVE ARENA
                </Typography>

                <Typography variant="h4" className="slot-hero-title">
                  3-SlotBET
                </Typography>
              </Box>
            </Stack>

            <Typography
              variant="body1"
              sx={{
                color: colors.slate[600],
                maxWidth: 520,
                lineHeight: 1.6,
                fontWeight: 500,
                fontSize: "0.95rem",
                mb: 2,
              }}
            >
              Spin the reels, match the symbols and win progressive jackpots.
              Simple gameplay with transparent on-chain results.
            </Typography>

            <Stack direction="row" gap={1.5} flexWrap="wrap" sx={{ gap: 1 }}>
              <CommonChip
                icon={<InstantIcon sx={{ fontSize: 16 }} />}
                label="3-Reel Slot"
                variant="neutral"
                size="small"
              />

              <CommonChip
                icon={<SparkleIcon sx={{ fontSize: 15 }} />}
                label="Progressive Jackpot"
                variant="neutral"
                size="small"
              />

              <CommonChip
                icon={<VerifiedIcon sx={{ fontSize: 15 }} />}
                label="On-Chain Results"
                variant="neutral"
                size="small"
              />
            </Stack>

            <Box sx={{ mt: 2 }}>
              <CommonButton
                variant="contained"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => history.push(`${Path.orgcreatelottery}?type=3slot`)}
                sx={{
                  bgcolor: "#8b5cf6",
                  "&:hover": { bgcolor: "#7c3aed" },
                  boxShadow: "0 4px 12px rgba(139, 92, 246, 0.25)",
                }}
              >
                Create 3-Slot Machine
              </CommonButton>
            </Box>
          </Grid>

          <Grid item xs={12} md={5}>
            <Stack
              direction={{
                xs: "column",
                sm: "row",
              }}
              spacing={2}
              justifyContent={{ md: "flex-end" }}
            >
              <Box className="slot-stat-card" sx={{ minWidth: 140 }}>
                <Typography
                  variant="caption"
                  sx={{
                    color: colors.slate[500],
                    fontWeight: 700,
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    display: "block",
                  }}
                >
                  Active Slots
                </Typography>

                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 900,
                    color: colors.slate[900],
                    my: 0.25,
                    fontFamily: "monospace",
                  }}
                >
                  {totalActive}
                </Typography>

                <Typography
                  variant="caption"
                  sx={{
                    color: colors.emerald[600],
                    fontWeight: 700,
                  }}
                >
                  Ready to Play
                </Typography>
              </Box>

              <Box className="slot-stat-card" sx={{ minWidth: 160 }}>
                <Typography
                  variant="caption"
                  sx={{
                    color: colors.slate[500],
                    fontWeight: 700,
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    display: "block",
                  }}
                >
                  Total Jackpot
                </Typography>

                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 900,
                    color: "#7c3aed",
                    my: 0.25,
                    fontFamily: "monospace",
                  }}
                >
                  {combinedPrize}{" "}
                  <Box
                    component="span"
                    sx={{
                      fontSize: "1rem",
                      fontWeight: 800,
                      color: colors.slate[700],
                    }}
                  >
                    {currency}
                  </Box>
                </Typography>

                <Typography
                  variant="caption"
                  sx={{
                    color: colors.slate[500],
                    fontWeight: 600,
                  }}
                >
                  Across all slots
                </Typography>
              </Box>
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default SlotHeroBanner;
